export default __webpack_public_path__ + "static/media/delivery-mobile.b01b182c.svg";